import { ref } from "vue";
import { registerNativeHandler } from "@/utils/reactNativeBus";

export function useNativeGetPushSubscription() {
  const derigesterHandler = ref(null);

  function getPushSubscription() {
    return new Promise((resolve) => {
      derigesterHandler.value = registerNativeHandler(
        "onUserPushSubscription",
        (payload) => {
          derigesterHandler.value();

          const { status, data } = payload;
          if (status === "success" && data && typeof data.subscription === 'string') {
            resolve(data.subscription);
          } else {
            resolve(null);
          }
        }
      );

      window.SababuuNativeBridge.getUserPushSubscription();
    });
  }

  return {
    getPushSubscription,
  };
}
